// @ts-nocheck
const theme = {
	primaryColor: '#e9e9eb',
};

export default theme;
